export const footer = {
  footerTitleGame: "Os melhores jogos",
  footerTitleGameCasino: "Cassino",
  footerTitleGameLottery: "Loteria",
  footerTitleGameGames: "Jogos",
  footerTitleSports: "Esportes",
  footerTitleGameSlots: "Slots",
  footerTitleGameMinigame: "Minijogos",
  footerTitleTestimonials: "Depoimentos",
  footerTitleNews: "Notícias",
  footerTitleLiga: "As ligas vencedoras",
  footerTitleLigaEsports: "E-Sports",
  footerTitleLigaLeague: "La Liga",
  footerTitleLigaFootball: "Liga dos Campeões da UEFA",
  footerTitleSupport: "Suporte",
  footerTitleHelp: "Central de ajuda",
  footerTitleTerms: "Termos e condições",
  footerTitleSocial: "Siga a gente",
  footerTitleApp: "Baixe nosso app",
  footerTitlePromotions: "Promoções",
  footerTitleResponsibleGambling: "Jogue com responsabilidade. Apenas para maiores de 18 anos.",
  footerTitleSafeGame: "Tudo por um jogo mais seguro",
  footerInfoTitle: "Informações",
  footerCategoriesTitle: "Categorias",
  footerContactSupport: "Fale com a gente",
  footerSupportDesc: "Alguma dúvida? Estamos aqui.",
  footerPromoTitle: "Rodadas grátis no seu primeiro depósito",
  footerPromoDesc: "1 rodada grátis a cada 40 Bs no seu primeiro depósito",
  footerPromoAvailable: "Disponível para Android e iOS",
  footerWinAppTitle: "Baixe o app para Windows e jogue no seu PC",
  footerInstallBtn: "Instalar",
  footerRegisterBtn: "Cadastre-se",
  footerGPlayTitle: "Baixe no Google Play",
  footerGPlayDesc: "A melhor experiência de jogo no seu Android",
  footerIOSTitle: "Baixe na App Store",
  footerIOSDesc: "Disponível para iPhone e iPad",
  footerDownloadBtn: "Baixar",
  footerGetItOn: "DISPONÍVEL NO",
  footerDownloadOn: "Baixe na",
};
